import {PublicClientApplication} from '@azure/msal-browser'
import {eqxAppConfigAuth} from '../interfaces/eqxAppConfig'
import eqxAuth from './eqxAuth'
import eqxEventBroker from './eqxEventBroker'

interface eqxAppConfigAuthMsal extends eqxAppConfigAuth {
    auth: {
        clientId: string
        authority: string
        redirectUri: string
        postLogoutRedirectUri?: string
        scopes: string[]
    }
    cache?: {
        cacheLocation: string
        storeAuthStateInCookie: boolean
    }
}
class eqxAuthMsal extends eqxAuth {
    config: eqxAppConfigAuthMsal
    events: eqxEventBroker
    msalInstance: PublicClientApplication | null = null

    constructor(config: eqxAppConfigAuthMsal) {
        super(config)
        this.config = config //this just for typescript validator
        this.events = new eqxEventBroker(this)
        this.msalInstance = this.init()
    }
    init() {
        if (!this.config.auth) throw new Error('No auth config provided')
        this.events.trigger('init', [this.config])
        return new PublicClientApplication(this.config)
    }
    getMsalInstance() {
        if (!this.msalInstance) throw new Error('Msal instance not initialized')
        return this.msalInstance
    }
    isAuthenticated() {
        const accounts = this.getMsalInstance().getAllAccounts()
        return accounts.length > 0
    }
    login() {
        this.events.trigger('loginStart')
        return this.getMsalInstance()
            .loginPopup({
                scopes: this.config.auth.scopes,
            })
            .then((response) => {
                this.events.trigger('loginSuccess', [response.accessToken])
                return response
            })
            .catch((val) => {
                this.events.trigger('loginError', [val])
                return val
            })
    }
    logout() {
        this.events.trigger('logoutStart')
        return this.getMsalInstance()
            .logoutPopup()
            .then((val) => {
                this.events.trigger('logoutSuccess', [val])
                return val
            })
            .catch((val) => {
                this.events.trigger('logoutError', [val])
                throw val
            })
    }
    getAccessToken(): Promise<string | null> {
        const accounts = this.getMsalInstance().getAllAccounts()
        if (!accounts.length) return Promise.resolve(null)

        const account = accounts[0]
        this.events.trigger('getAccesTokenStart')
        return this.getMsalInstance()
            .acquireTokenSilent({
                scopes: this.config.auth.scopes,
                account: account,
            })
            .then((response) => {
                console.log('Got token on AuthProvider', response)
                this.events.trigger('getAccessTokenSuccess', [response.accessToken])
                return response.accessToken
            })
            .catch((e) => {
                console.log('Error getting token on AuthProvider', e)
                this.events.trigger('getAccessTokenError', [e])
                return null
            })
    }
}
export {eqxAuthMsal as default, type eqxAppConfigAuthMsal}
